import {
  PRINTLABEL_INDIVIDUALPRINT_REQUEST,
  PRINTLABEL_INDIVIDUALPRINT_SUCCESS,
  PRINTLABEL_INDIVIDUALPRINT_FAILURE,
  PRINTLABEL_PACKAGEPRINT_REQUEST,
  PRINTLABEL_PACKAGEPRINT_SUCCESS,
  PRINTLABEL_PACKAGEPRINT_FAILURE,
} from "./labelPrintingTypes";
import axios from "axios";
import Config from "../../config/index";

let baseUrl = Config.baseUrl;

const individualPrintRequest = () => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_REQUEST,
  };
};

const individualPrintSuccess = (payload) => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_SUCCESS,
    payload: payload,
  };
};

const individualPrintFailure = (error) => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_FAILURE,
    payload: error,
  };
};

const individualPrint = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(individualPrintRequest());
    let url = `${baseUrl}/print/ind`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(individualPrintSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(individualPrintFailure(err.response));
        return { status: false, message: err.response };
      });
  };
};

const packagePrintRequest = () => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_REQUEST,
  };
};

const packagePrintSuccess = (payload) => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_SUCCESS,
    payload: payload,
  };
};

const packagePrintFailure = (error) => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_FAILURE,
    payload: error,
  };
};

const packagePrint = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(packagePrintRequest());
    let url = `${baseUrl}/print/pkg`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(packagePrintSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(packagePrintFailure(err.response));
        return { status: false, message: err.response };
      });
  };
};

const individualPrintWithPicklistCreationRequest = () => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_REQUEST,
  };
};

const individualPrintWithPicklistCreationSuccess = (payload) => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_SUCCESS,
    payload: payload,
  };
};

const individualPrintWithPicklistCreationFailure = (error) => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_FAILURE,
    payload: error,
  };
};

const individualPrintWithPicklistCreation = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(individualPrintWithPicklistCreationRequest());
    let url = `${baseUrl}/grn_v1/print/ind_with_picklist`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(individualPrintWithPicklistCreationSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(individualPrintWithPicklistCreationFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const packagePrintWithPicklistCreationRequest = () => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_REQUEST,
  };
};

const packagePrintWithPicklistCreationSuccess = (payload) => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_SUCCESS,
    payload: payload,
  };
};

const packagePrintWithPicklistCreationFailure = (error) => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_FAILURE,
    payload: error,
  };
};

const packagePrintWithPicklistCreation = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(packagePrintWithPicklistCreationRequest());
    let url = `${baseUrl}/grn_v1/print/pkg_with_picklist`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(packagePrintWithPicklistCreationSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(packagePrintWithPicklistCreationFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const individualPrintWithPickupRequest = () => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_REQUEST,
  };
};

const individualPrintWithPickupSuccess = (payload) => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_SUCCESS,
    payload: payload,
  };
};

const individualPrintWithPickupFailure = (error) => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_FAILURE,
    payload: error,
  };
};

const individualPrintWithPickup = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(individualPrintWithPickupRequest());
    let url = `${baseUrl}/grn_v1/print/ind_with_pickup`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(individualPrintWithPickupSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(individualPrintWithPickupFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const packagePrintWithPickupRequest = () => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_REQUEST,
  };
};

const packagePrintWithPickupSuccess = (payload) => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_SUCCESS,
    payload: payload,
  };
};

const packagePrintWithPickupFailure = (error) => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_FAILURE,
    payload: error,
  };
};

const packagePrintWithPickup = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(packagePrintWithPickupRequest());
    let url = `${baseUrl}/grn_v1/print/pkg_with pickup`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(packagePrintWithPickupSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(packagePrintWithPickupFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const individualPrintWithPutawayRequest = () => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_REQUEST,
  };
};

const individualPrintWithPutawaySuccess = (payload) => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_SUCCESS,
    payload: payload,
  };
};

const individualPrintWithPutawayFailure = (error) => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_FAILURE,
    payload: error,
  };
};

const individualPrintWithPutaway = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(individualPrintWithPutawayRequest());
    let url = `${baseUrl}/grn_v1/print/ind_with_putaway`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(individualPrintWithPutawaySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(individualPrintWithPutawayFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const packagePrintWithPutawayRequest = () => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_REQUEST,
  };
};

const packagePrintWithPutawaySuccess = (payload) => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_SUCCESS,
    payload: payload,
  };
};

const packagePrintWithPutawayFailure = (error) => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_FAILURE,
    payload: error,
  };
};

const packagePrintWithPutaway = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(packagePrintWithPutawayRequest());
    let url = `${baseUrl}/grn_v1/print/pkg_with_putaway`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(packagePrintWithPutawaySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(packagePrintWithPutawayFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const individualPrintForV1W2Request = () => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_REQUEST,
  };
};

const individualPrintForV1W2Success = (payload) => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_SUCCESS,
    payload: payload,
  };
};

const individualPrintForV1W2Failure = (error) => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_FAILURE,
    payload: error,
  };
};

const individualPrintForV1W2 = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(individualPrintForV1W2Request());
    let url = `${baseUrl}/grn/v1w2/print/ind`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(individualPrintForV1W2Success(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(individualPrintForV1W2Failure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const packagePrintForV1W2Request = () => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_REQUEST,
  };
};

const packagePrintForV1W2Success = (payload) => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_SUCCESS,
    payload: payload,
  };
};

const packagePrintForV1W2Failure = (error) => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_FAILURE,
    payload: error,
  };
};

const packagePrintForV1W2 = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(packagePrintForV1W2Request());
    let url = `${baseUrl}/grn/v1w2/print/pkg`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(packagePrintForV1W2Success(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(packagePrintForV1W2Failure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const individualPrintForV1W3Request = () => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_REQUEST,
  };
};

const individualPrintForV1W3Success = (payload) => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_SUCCESS,
    payload: payload,
  };
};

const individualPrintForV1W3Failure = (error) => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_FAILURE,
    payload: error,
  };
};

const individualPrintForV1W3 = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(individualPrintForV1W3Request());
    let url = `${baseUrl}/grn/v1w3/print/ind`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(individualPrintForV1W3Success(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(individualPrintForV1W3Failure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const packagePrintForV1W3Request = () => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_REQUEST,
  };
};

const packagePrintForV1W3Success = (payload) => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_SUCCESS,
    payload: payload,
  };
};

const packagePrintForV1W3Failure = (error) => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_FAILURE,
    payload: error,
  };
};

const packagePrintForV1W3 = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(packagePrintForV1W3Request());
    let url = `${baseUrl}/grn/v1w3/print/pkg`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(packagePrintForV1W3Success(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(packagePrintForV1W3Failure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const individualPrintForV1W4Request = () => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_REQUEST,
  };
};

const individualPrintForV1W4Success = (payload) => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_SUCCESS,
    payload: payload,
  };
};

const individualPrintForV1W4Failure = (error) => {
  return {
    type: PRINTLABEL_INDIVIDUALPRINT_FAILURE,
    payload: error,
  };
};

const individualPrintForV1W4 = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(individualPrintForV1W4Request());
    let url = `${baseUrl}/grn/v1w4/print/ind`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(individualPrintForV1W4Success(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(individualPrintForV1W4Failure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const packagePrintForV1W4Request = () => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_REQUEST,
  };
};

const packagePrintForV1W4Success = (payload) => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_SUCCESS,
    payload: payload,
  };
};

const packagePrintForV1W4Failure = (error) => {
  return {
    type: PRINTLABEL_PACKAGEPRINT_FAILURE,
    payload: error,
  };
};

const packagePrintForV1W4 = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(packagePrintForV1W4Request());
    let url = `${baseUrl}/grn/v1w4/print/pkg`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(packagePrintForV1W4Success(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(packagePrintForV1W4Failure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export {
  individualPrint,
  packagePrint,
  individualPrintWithPicklistCreation,
  packagePrintWithPicklistCreation,
  individualPrintWithPickup,
  packagePrintWithPickup,
  individualPrintWithPutaway,
  packagePrintWithPutaway,
  individualPrintForV1W2,
  packagePrintForV1W2,
  individualPrintForV1W3,
  packagePrintForV1W3,
  individualPrintForV1W4,
  packagePrintForV1W4,
};
